import { Injectable } from '@angular/core';
import { Organization, UserToken } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _isAuthenticated: boolean;

  constructor() {
    this._isAuthenticated = false;
  }

  get token(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser ? currentUser.token : null;
  }

  get organization(): Organization {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser ? currentUser.organization : null;  
  }

  set organization(value: Organization) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      currentUser.organization = value;
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    }
  }

  get user(): UserToken {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return (currentUser && new Date(currentUser.expiration) > new Date()) ? currentUser : null;
    // const token = '';
    // const tokenArray = token.split('.');
  }

  get isAuthenticated(): boolean {

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (this.token && (currentUser && new Date(currentUser.expiration) > new Date())) {
      this._isAuthenticated = true;
    }

    return this._isAuthenticated;
  }

  set isAuthenticated(v: boolean) {
    this._isAuthenticated = v;
  }

}
